var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAl(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 12,
    viewBox: "0 0 16 12",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0f0f0"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "b",
    height: 11.428571,
    rx: 1,
    width: 16
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ee343c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e2222a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#262626"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0d0d0d"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "e",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    fillRule: "evenodd",
    xlinkHref: "#b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#a)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0h16v11.428571h-16z",
    fill: "url(#c)",
    mask: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.12220982 2.55078125.61272321.61272321c.14276122.14276123.38374148.14639245.53013394 0l.6127232-.61272321c.14276122-.14276123.40488427-.17185541.57735772-.05687314l.83056641.55371094-1.17941502.58970751c-.18940008.09470004-.34439452.34275544-.34439452.55314963 0 .20424107.17055817.38095238.38095238.38095238.20424107 0 .53236198-.07570478.71913509-.16909136l.84744407-.42372204c.1865031-.09325154.4574887-.0497854.6046601.09738595l.2289501.22895014c.1474297.14742969.1150677.3421821-.0717054.43556867l-.8474441.42372204c-.1865031.09325155-.1983654.26230291-.025892.37728518l.5182757.34551712c.172154.11476935.1478641.24107916-.0549665.28164528l-1.17024746.23404947c-.20485828.04097167-.22919725.17699644-.05889165.30472565l.90707841.68030875c.1677406.12580545.1378074.2312742-.0725868.2312742-.2042411 0-.5461019-.04128738-.74982419-.09221794l-.78606598-.1965165c-.20579748-.05144936-.27566019.04759938-.16067794.22007279l.34551711.51827567c.11476937.17215406.03496419.31229074-.17872549.31229074h-.36901851c-.21828679 0-.44088503.16189707-.50745501.36160716l-.13988099.41964282c-.06756587.20269775-.17450141.1997101-.2410714 0l-.13988099-.41964282c-.06756586-.20269775-.29376536-.36160716-.50745498-.36160716h-.36901856c-.21828678 0-.29370774-.13981729-.17872547-.31229074l.34551712-.51827567c.11476934-.17215402.04304429-.27100335-.16067796-.22007279l-.78606597.1965165c-.20579747.05144936-.53942997.09221794-.74982416.09221794-.20424107 0-.2428924-.10354498-.07258679-.2312742l.90707834-.68030875c.1677406-.12580545.14393892-.26415953-.05889166-.30472565l-1.17024739-.23404947c-.20485833-.04097167-.22743993-.16666301-.05496652-.28164528l.51827567-.34551712c.17215402-.11476934.16088117-.2838986-.02589199-.37728518l-.84744408-.42372204c-.18650309-.09325154-.21887676-.28839732-.07170541-.43556867l.22895014-.22895014c.14742969-.14742969.41788687-.19077253.60466003-.09738595l.84744409.42372204c.18650309.09325154.50874091.16909136.7191351.16909136.20424107 0 .38095238-.17055819.38095238-.38095238 0-.20424107-.15140956-.45665717-.33818272-.55004374l-.84744409-.42372204c-.18650309-.09325155-.19836539-.26230291-.02589198-.37728518l.51827567-.34551712c.17215402-.11476934.43096526-.0895193.5773577.05687314z",
    fill: "url(#d)",
    mask: "url(#e)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAl);
export default __webpack_public_path__ + "static/media/AL.d4aa0b8a730e62353c5b1b6fd7de2af7.svg";
export { ForwardRef as ReactComponent };